import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createStaticVNode as _createStaticVNode } from "vue"
import _imports_0 from '@/assets/Logo nova.png'


const _hoisted_1 = { class: "bg-white p-8 text-center relative overflow-hidden" }
const _hoisted_2 = {
  key: 0,
  class: "relative z-10 mb-6 inline-block"
}


export default /*@__PURE__*/_defineComponent({
  __name: 'ResetHeader',
  props: {
  title: { type: String, default: 'Nova' },
  subtitle: { type: String, default: 'Innovación de ventas sin límites' },
  showLogo: { type: Boolean, default: true }
},
  setup(__props) {

const props = __props

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (__props.showLogo)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [...(_cache[0] || (_cache[0] = [
          _createElementVNode("div", { class: "w-40 h-40 flex items-center justify-center" }, [
            _createElementVNode("img", {
              src: _imports_0,
              alt: "Nova Logo",
              class: "w-full h-full object-contain"
            })
          ], -1)
        ]))]))
      : _createCommentVNode("", true),
    _cache[1] || (_cache[1] = _createStaticVNode("<div class=\"relative z-10 mt-6 flex justify-center gap-2\" data-v-5adac9c1><div class=\"w-2 h-2 bg-gray-400 rounded-full animate-pulse\" data-v-5adac9c1></div><div class=\"w-2 h-2 bg-red-500 rounded-full animate-pulse delay-100\" data-v-5adac9c1></div><div class=\"w-2 h-2 bg-gray-400 rounded-full animate-pulse delay-200\" data-v-5adac9c1></div><div class=\"w-2 h-2 bg-red-500 rounded-full animate-pulse delay-300\" data-v-5adac9c1></div></div>", 1))
  ]))
}
}

})